export default __webpack_public_path__ + "static/media/Path 97884.ff3f7b6a.svg";